/* prettier-ignore */

const data = {
  common: {
    title: "Piggy Valut",
    description: "Piggy Valut Solution",
    buttons: {
      search: "Tìm kiếm",
      login: "Đăng nhập",
      register: "Đăng ký",
      approve: "Phê duyệt",
      reject: "Từ chối",
      refresh: "Làm mới",
      viewDetails: "Xem chi tiết",
      back: "Quay lại",
      cancel: "Hủy",
      confirm: "Xác nhận",
      save: "Lưu",
      saving: "Đang lưu...",
      delete: "Xóa",
      deleting: "Đang xóa...",
      hide: "Ẩn",
      show: "Hiển thị",
      close: "Đóng",
    },
    placeholders: {
      search: "Tìm kiếm...",
    },
    messages: {
      success: "Thành công",
      updateSuccess: "Thông tin người dùng đã được cập nhật",
      loginSuccess: "Đăng nhập thành công",
      logoutSuccess: "Đăng xuất thành công",
      registerSuccess: "Đăng ký thành công",
      criticalError: "Đã xảy ra lỗi nghiêm trọng",
      forbidden: "Yêu cầu bị cấm",
      notAuthorized: "Không được phép",
      noData: "Không có dữ liệu",
      tooManyRequests: "Vui lòng thử lại sau. Bạn đang gửi yêu cầu giống nhau quá nhanh.",
      blocked: "Người dùng bị chặn",
      pending: "Người dùng đang chờ xử lý",
      ipBlocked: "IP bị chặn",
      serverError: "Đã xảy ra lỗi máy chủ",
      invalidInput: "Đầu vào không hợp lệ",
      invalidCredentials: "Tên người dùng hoặc mật khẩu không chính xác",
      invalidReferrer: "Người giới thiệu không tồn tại",
      referrerRequired: "Yêu cầu người giới thiệu",
      ipBlockedFailed: "Không thể chặn IP",
      notAllowedPartner: "Đối tác không được phép",
      invalidPassword: "Không thể xác minh mật khẩu",
      databaseError: "Đã xảy ra lỗi cơ sở dữ liệu",
      usernameInUse: "Tên người dùng đã được sử dụng",
      createUserError: "Không thể tạo người dùng",
      failedFetch: "Không thể tải dữ liệu",
      failedFetchUser: "Không thể tải thông tin người dùng",
      failedFetchPendingUsers: "Không thể tải danh sách người dùng đang chờ",
      failedFetchOnlineUsers: "Không thể tải danh sách người dùng trực tuyến",
      failedFetchUserTree: "Không thể tải cây người dùng",
      failedFetchUsers: "Không thể tải danh sách người dùng",
      failedFetchUserUpline: "Không thể tải thông tin người dùng upline",
      failedFetchUserDownline: "Không thể tải thông tin người dùng downline",
      failedUpdate: "Không thể cập nhật dữ liệu",
      failedUpdateUser: "Không thể cập nhật người dùng",
      failedSave: "Không thể lưu dữ liệu",
      vendorError: "Đã xảy ra lỗi nhà cung cấp",
      confirmDelete: "Bạn có chắc chắn muốn xóa?",
      deleteSuccess: "Người dùng đã bị xóa",
      tokenRefreshed: "Token đã được làm mới",
      tokenRefreshFailed: "Không thể làm mới token",
      invalidIpAddress: "Địa chỉ IP không hợp lệ",
      invalidChipTransactionReason: "Lý do giao dịch chip không hợp lệ",
      captchaExpired: "Captcha đã hết hạn",
      captchaInvalid: "Captcha không hợp lệ",
      insufficientChip: "Chip không đủ",
      insufficientPoint: "Điểm không đủ",
      failedCollectChips: "Không thể thu thập chip",
      failedGiveChips: "Không thể cấp chip",
      failedPointsToChips: "Không thể chuyển điểm thành chip",
      notFoundHeadquarter: "Không tìm thấy trụ sở",
      notFoundUser: "Không tìm thấy người dùng",
      failedFetchAdmin: "Không thể tải thông tin admin",
      failedFetchHeadquarter: "Không thể tải thông tin trụ sở",
      adminNotAllowed: "Admin không được phép",
      partnerNotAllowed: "Đối tác không được phép",
      userNotAllowed: "Người dùng không được phép",
      failedFetchTotalInquiries: "Không thể tải tổng số yêu cầu",
      failedFetchInquiries: "Không thể tải danh sách yêu cầu",
      failedCreateInquiry: "Không thể tạo yêu cầu",
      failedUpdateInquiry: "Không thể cập nhật yêu cầu",
      failedFetchInquiry: "Không thể tải yêu cầu",
      failedFetchTotalNotices: "Không thể tải tổng số thông báo",
      failedFetchNotices: "Không thể tải danh sách thông báo",
      failedCreateNotice: "Không thể tạo thông báo",
      failedUpdateNotice: "Không thể cập nhật thông báo",
      failedIncrementNoticeViewCount: "Không thể tăng lượt xem thông báo",
      failedFetchNotice: "Không thể tải thông báo",
      failedFetchBankingHistory: "Không thể tải lịch sử giao dịch ngân hàng",
      failedFetchTotalBankingHistory: "Không thể tải tổng số lịch sử giao dịch ngân hàng",
      failedFetchDownlineBankingHistory: "Không thể tải lịch sử giao dịch ngân hàng của tuyến dưới",
      failedFetchDownlineTotalBankingHistory: "Không thể tải tổng số lịch sử giao dịch ngân hàng của tuyến dưới",
      failedAddBankingHistory: "Không thể thêm lịch sử giao dịch ngân hàng",
      failedUpdateBankingHistoryStatus: "Không thể cập nhật trạng thái lịch sử giao dịch ngân hàng",
      failedFetchChipTransactionHistory: "Không thể tải lịch sử giao dịch chip",
      failedFetchTotalChipTransactionHistory: "Không thể tải tổng số lịch sử giao dịch chip",
      failedFetchDownlineChipTransactionHistory: "Không thể tải lịch sử giao dịch chip của tuyến dưới",
      failedFetchDownlineTotalChipTransactionHistory: "Không thể tải tổng số lịch sử giao dịch chip của tuyến dưới",
      failedAddChipTransactionHistory: "Không thể thêm lịch sử giao dịch chip",
      failedFetchGameBetHistoryByCallbackId: "Không thể tải lịch sử cược game bằng ID callback",
      failedFetchGameBetHistory: "Không thể tải lịch sử cược game",
      failedFetchTotalGameBetHistory: "Không thể tải tổng số lịch sử cược game",
      failedFetchDownlineGameBetHistory: "Không thể tải lịch sử cược game của tuyến dưới",
      failedFetchDownlineTotalGameBetHistory: "Không thể tải tổng số lịch sử cược game của tuyến dưới",
      failedAddGameBetHistory: "Không thể thêm lịch sử cược game",
      failedFetchChipChangeHistory: "Không thể tải lịch sử thay đổi chip",
      failedFetchTotalChipChangeHistory: "Không thể tải tổng số lịch sử thay đổi chip",
      failedAddChipChangeHistory: "Không thể thêm lịch sử thay đổi chip",
      failedFetchGameCallbackHistory: "Không thể tải lịch sử gọi lại trò chơi",
      failedFetchTotalGameCallbackHistory: "Không thể tải tổng số lịch sử gọi lại trò chơi",
      failedAddGameCallbackHistory: "Không thể thêm lịch sử gọi lại trò chơi",
      failedUpdateGameCallbackHistory: "Không thể cập nhật lịch sử gọi lại trò chơi",
      failedDeleteGameCallbackHistory: "Không thể xóa lịch sử gọi lại trò chơi",
      failedFetchGamePlayHistory: "Không thể tải lịch sử chơi game",
      failedFetchTotalGamePlayHistory: "Không thể tải tổng số lịch sử chơi game",
      failedAddGamePlayHistory: "Không thể thêm lịch sử chơi game",
      failedFetchLoginHistory: "Không thể tải lịch sử đăng nhập",
      failedFetchTotalLoginHistory: "Không thể tải tổng số lịch sử đăng nhập",
      failedAddLoginHistory: "Không thể thêm lịch sử đăng nhập",
      failedFetchPointChangeHistory: "Không thể tải lịch sử thay đổi điểm",
      failedFetchTotalPointChangeHistory: "Không thể tải tổng số lịch sử thay đổi điểm",
      failedAddPointChangeHistory: "Không thể thêm lịch sử thay đổi điểm",
      failedFetchSettings: "Không thể tải cài đặt",
      failedFetchSettingByKey: "Không thể tải cài đặt theo khóa",
      failedCreateSetting: "Không thể tạo cài đặt",
      noFieldsToUpdateSetting: "Không có trường nào để cập nhật",
      settingNotFound: "Không tìm thấy cài đặt",
      failedUpdateSetting: "Không thể cập nhật cài đặt",
      failedDeleteSetting: "Không thể xóa cài đặt",
      failedUpdateMultipleSettings: "Không thể cập nhật nhiều cài đặt",
      failedFetchUserDownlineTotalFinance: "Không thể tải tổng tài chính tuyến dưới",
      failedFetchUserDownlineSettlement: "Không thể tải quyết toán tuyến dưới",
      failedFetchMyTotalAddedChips: "Không thể tải tổng số chip đã thêm của tôi",
      failedFetchMyTotalSubtractedChips: "Không thể tải tổng số chip đã trừ của tôi",
      failedFetchMyMoneyChanges: "Không thể tải thay đổi tiền của tôi",
      failedFetchTodaysNewUsers: "Không thể tải số người dùng mới hôm nay",
      failedFetchTodayStats: "Không thể tải thống kê hôm nay",
      failedFetchTotalPendingUsers: "Không thể tải tổng số người dùng đang chờ xử lý",
      failedFetchTotalOnlineUsers: "Không thể tải tổng số người dùng trực tuyến",
      failedFetchTotalPendingInquiries: "Không thể tải tổng số yêu cầu đang chờ xử lý",
      failedFetchTotalDepositAndWithdraw: "Không thể tải tổng thông tin nạp và rút tiền",
      failedFetchMonitoringStats: "Không thể tải thống kê giám sát",
      failedUpdateUserFinance: "Không thể cập nhật tài chính người dùng",
      failedAddUserChip: "Không thể thêm chip cho người dùng",
      failedAddUserPoint: "Không thể thêm điểm cho người dùng",
      failedSubtractUserChip: "Không thể trừ chip của người dùng",
      failedCollectSubUserChips: "Không thể thu thập chip từ người dùng cấp dưới",
      failedGiveChipsToSubUser: "Không thể cấp chip cho người dùng phụ",
      failedUpdateUserStatus: "Không thể cập nhật trạng thái người dùng",
      failedUpdateUserRole: "Không thể cập nhật vai trò người dùng",
      failedUpdateUserOnlineStatus: "Không thể cập nhật trạng thái trực tuyến của người dùng",
      failedUpdateGameVendorForDownline: "Không thể cập nhật nhà cung cấp game cho tuyến dưới",
      failedCreateUsers: "Không thể tạo nhiều người dùng",
      failedFetchUserById: "Không thể tải người dùng theo ID",
      failedFetchUserByVendorId: "Không thể tải người dùng theo ID nhà cung cấp",
      failedFetchUserFinance: "Không thể tải tài chính người dùng",
      failedFetchUserRowsByRole: "Không thể tải số lượng người dùng theo vai trò",
      failedFetchAdminId: "Không thể tải ID admin",
      failedFetchHeadquarterId: "Không thể tải ID trụ sở",
      failedFetchUsersByReferrer: "Không thể tải người dùng theo người giới thiệu",
      failedFetchUsersWithoutReferrer: "Không thể tải người dùng không có người giới thiệu",
      failedFetchPendingUsersTotal: "Không thể tải tổng số người dùng đang chờ xử lý",
      failedFetchOnlineUsersTotal: "Không thể tải tổng số người dùng trực tuyến",
      failedFetchUserDetail: "Không thể tải chi tiết người dùng",
      userNotFound: "Không tìm thấy người dùng",
      failedFetchVendorHistory: "Không thể tải lịch sử nhà cung cấp",
      failedAddVendorHistory: "Không thể thêm lịch sử nhà cung cấp",
      failedUpdateVendorHistory: "Không thể cập nhật lịch sử nhà cung cấp",
      referrerNotFound: "Không tìm thấy người giới thiệu",
      failedToGetAdminId: "Không thể lấy ID quản trị viên",
      failedToGetHeadquarterId: "Không thể lấy ID trụ sở chính",
      failedToGetUserDetail: "Không thể lấy thông tin chi tiết người dùng",
      failedToGetUserFinance: "Không thể lấy thông tin tài chính người dùng",
      failedFetchUserByRole: "Không thể lấy người dùng theo vai trò",
      failedAddBetAmount: "Không thể thêm số tiền cược",
      invalidReason: "Lý do không hợp lệ",
      refreshTokenRequired: "Yêu cầu token làm mới",
    },
    pagination: {
      previous: "Trước",
      next: "Tiếp",
      page: "Trang",
    },
    roles: {
      admin: "Admin",
      headquarter: "Trụ sở",
      headquarter_branch: "Trụ sở chi nhánh",
      branch: "Chi nhánh",
      distributor: "Nhà phân phối",
      store: "Cửa hàng",
      user: "Người dùng",
    },
    appBar: {
      search: {
        placeholder: "Tìm kiếm...",
      },
      userProfile: "Hồ sơ",
      userSettings: "Cài đặt",
      darkMode: "Chế độ tối",
      lightMode: "Chế độ sáng",
      logout: "Đăng xuất",
    },
    loading: {
      loading: "Đang tải...",
      error: "Đã xảy ra lỗi: ",
    },
    search: {
      placeholder: "Nhập từ khóa tìm kiếm",
      button: "Tìm kiếm",
      datePlaceholder: "Chọn ngày",
    },
    userTree: {
      title: "Sơ đồ tổ chức",
    },
    status: {
      pending: "Đang chờ",
      approved: "Đã phê duyệt",
      rejected: "Đã từ chối",
      canceled: "Đã hủy",
    },
    gameVendorSelect: {
      officialLabel: "Nhà cung cấp trò chơi chính thức",
      unofficialLabel: "Nhà cung cấp trò chơi không chính thức",
      officialPlaceholder: "Chọn nhà cung cấp trò chơi chính thức",
      unofficialPlaceholder: "Chọn nhà cung cấp trò chơi không chính thức",
      save: "Lưu",
      none: "Không có",
    },
    dateRangeSelector: {
      startDatePlaceholder: "Ngày bắt đầu",
      endDatePlaceholder: "Ngày kết thúc",
      selectPlaceholder: "Chọn khoảng thời gian",
      periods: {
        day: "Hôm nay",
        week: "1 tuần",
        twoWeeks: "2 tuần",
        month: "1 tháng",
        threeMonths: "3 tháng",
        sixMonths: "6 tháng",
        year: "1 năm",
        custom: "Tùy chỉnh",
      },
    },
  },
  auth: {
    login: "Đăng nhập",
    register: "Đăng ký",
    loginDescription: "Nhập tên người dùng và mật khẩu để đăng nhập",
    registerDescription: "Tạo tài khoản mới",
    email: "Email",
    password: "Mật khẩu",
    username: "Tên người dùng",
    referrer: "Người giới thiệu",
    referrerPlaceholder: "Nhập tên người dùng người giới thiệu",
    confirmPassword: "Xác nhận mật khẩu",
    loginButton: "Đăng nhập",
    registerButton: "Đăng ký",
    captcha: "Câu hỏi bảo mật",
    captchaPlaceholder: "Nhập câu trả lời",
    loginProcessing: "Đang đăng nhập...",
    registerProcessing: "Đang xử lý...",
    hasAccount: "Đã có tài khoản?",
    noAccount: "Chưa có tài khoản?",
    goToLogin: "Đi đến đăng nhập",
    goToRegister: "Đi đến đăng ký",
    minLengthUsername: "Tên người dùng phải có ít nhất 3 ký tự",
    minLengthPassword: "Mật khẩu phải có ít nhất 8 ký tự",
    invalidCaptcha: "Câu trả lời câu hỏi bảo mật không chính xác",
    passwordMismatch: "Mật khẩu không khớp",
    loginSuccess: "Đăng nhập thành công",
    registerSuccess: "Đăng ký thành công",
    refresh: "Làm mới",
  },
  sidebar: {
    systemManagement: "Hệ thống/Thông báo",
    partnerManagement: "Quản lý đối tác",
    userManagement: "Quản lý người dùng",
    bankingManagement: "Quản lý ngân hàng",
    bettingStatus: "Trạng thái & Thanh toán cá cược",
    apiDocs: "Tài liệu API",
    settings: "Cài đặt",
  },
  statsOverview: {
    balance: "Số dư",
    pendingApproval: "Đang chờ phê duyệt",
    depositRequest: "Yêu cầu nạp tiền",
    withdrawRequest: "Yêu cầu rút tiền",
    inquiry: "Hỏi đáp 1:1",
    currentUsers: "Người dùng hiện tại",
    cases: "Trường hợp",
    users: "Người dùng",
    userBalance: "Số dư chip người dùng",
    userPoint: "Số điểm người dùng", 
    partnerBalance: "Số dư chip đối tác",
    partnerPoint: "Số điểm đối tác",
  },
  dashboard: {
    title: "Bảng điều khiển",
    desc: "Bảng điều khiển Admin",
    registeredUsers: "Người dùng đã đăng ký",
    activeUsers: "Người dùng đang hoạt động",
    systemStatus: "Trạng thái hệ thống",
    systemNormal: "Bình thường",
    allSystemsOperational: "Tất cả hệ thống đang hoạt động",
    topStats: {
      chip: {
        title: "Số dư chip",
        vendorBalance: "Số dư chip nhà cung cấp",
      },
      point: {
        title: "Số dư điểm",
        convertButton: "Chuyển đổi thành chip",
      },
      user: {
        title: "Người dùng",
        listButton: "Danh sách người dùng liên kết",
      },
    },
    moneyStatus: {
      userBalance: "Số dư chip người dùng",
      userPoint: "Số dư điểm người dùng",
      partnerBalance: "Số dư chip đối tác",
      partnerPoint: "Số dư điểm đối tác",
    },
    transactionSummary: {
      deposit: "Nạp tiền",
      withdraw: "Rút tiền",
      chipGive: "Cấp chip",
      chipCollect: "Thu thập chip",
      newUsers: "Người dùng mới hôm nay",
      profit: "Lợi nhuận cá cược hôm nay",
      profitDesc: "(Cược - Thắng - Rolling)",
    },
    transactionDetails: {
      title: "Số dư = Chip + Rolling, Nạp tiền/Rút tiền là tổng số tiền nạp/rút của thành viên liên kết",
      search: "Tìm kiếm",
      prevBalance: "Số dư trước",
      deposit: "Nạp tiền",
      withdraw: "Rút tiền",
      currentBalance: "Số dư hiện tại",
      bettingWinning: "Cược / Thắng",
      rolling: "Rolling",
      userBalanceLabel: "Số dư người dùng",
      partnerBalanceLabel: "Số dư đối tác",
      depositLabel: "Nạp tiền",
      chipGiveLabel: "Cấp chip",
      totalLabel: "Tổng cộng",
      withdrawLabel: "Rút tiền",
      chipCollectLabel: "Thu thập chip",
      bettingLabel: "Số tiền cược",
      winningLabel: "Số tiền thắng",
      bettingResultLabel: "Cược - Thắng",
      totalRollingLabel: "Tổng rolling",
      actualRollingLabel: "Rolling thực tế",
    },
    transactionHistory: {
      title: "Lịch sử giao dịch",
      search: "Tìm kiếm",
      increase: {
        title: "Tăng số dư",
        headDeposit: "Nạp tiền công ty",
        upperChipGive: "Cấp chip upline",
        lowerChipCollect: "Thu thập chip downline",
        rollingConvert: "Chuyển đổi rolling",
        total: "Tổng tăng",
      },
      decrease: {
        title: "Giảm số dư",
        headWithdraw: "Rút tiền công ty",
        upperChipCollect: "Thu thập chip upline",
        lowerChipGive: "Cấp chip downline",
        total: "Tổng giảm",
      },
    },
    notice: {
      title: "Thông báo",
      columns: {
        id: "#",
        title: "Tiêu đề",
        createdAt: "Ngày tạo",
      },
    },
  },
  users: {
    list: {
      title: "Danh sách người dùng",
      desc: "Quản lý người dùng đã đăng ký",
      columns: {
        username: "ID người dùng",
        details: "Chi tiết",
        banking: "Nạp/Đổi",
        chip: "Số dư chip",
        point: "Số điểm",
        affiliation: "Liên kết",
        depositWithdraw: "Nạp/Rút",
        slotStats: "(Slot)/Cược/Thắng/Rolling",
        casinoStats: "(Casino)/Cược/Thắng/Rolling",
        sportsStats: "(Thể thao)/Cược/Thắng/Rolling",
      },
      filters: {
        byUsername: "Theo ID người dùng",
        byChip: "Theo số dư chip",
        byLatest: "Theo mới nhất",
        byOldest: "Theo cũ nhất",
      },
    },
    pending: {
      title: "Người dùng đang chờ",
      desc: "Quản lý người dùng đang chờ",
      columns: {
        username: "ID người dùng",
        details: "Chi tiết",
        status: "Trạng thái",
        headquarter: "Trụ sở",
        branch: "Chi nhánh",
        distributor: "Nhà phân phối",
        store: "Cửa hàng",
        createdAt: "Ngày tạo",
        contact: "Số điện thoại",
        actions: "Hành động",
      },
      approve: "Phê duyệt",
      reject: "Từ chối",
      pendingStatus: "Đang chờ",
      viewDetails: "Xem chi tiết",
    },
    online: {
      title: "Người dùng trực tuyến",
      desc: "Quản lý người dùng trực tuyến",
      columns: {
        username: "ID người dùng",
        details: "Chi tiết",
        accountHolder: "Chủ tài khoản",
        affiliation: "Liên kết",
        banking: "Nạp/Đổi",
        chip: "Số dư chip",
        depositWithdraw: "Tổng nạp/rút",
        slotStats: "(Slot)/Cược/Thắng/Rolling",
        casinoStats: "(Casino)/Cược/Thắng/Rolling",
        sportsStats: "(Thể thao)/Cược/Thắng/Rolling",
        lastPlayedGame: "Trò chơi cuối cùng",
      },
      noLastGame: "Không có ghi chép",
    },
    chip: {
      giveTitle: "Cấp chip",
      collectTitle: "Thu thập chip",
      giftTitle: "Tặng chip",
      giveChip: "Cấp chip",
      collectChip: "Thu thập chip",
      giftChip: "Tặng chip",
      description: "Nhập số lượng và lý do, sau đó nhấp vào nút xác nhận.",
      amount: "Số lượng",
      memo: "Ghi chú",
      memoPlaceholder: "Nhập ghi chú",
      errors: {
        invalidAmount: "Nhập số lượng hợp lệ",
        actionFailed: "Hành động thất bại",
      },
    },
    status: {
      active: "Hoạt động",
      pending: "Đang chờ",
      rejected: "Đã từ chối",
      block: "Bị chặn",
      online: "Trực tuyến",
      offline: "Ngoại tuyến",
    },
    detail: {
      title: "Chi tiết người dùng",
      desc: "Quản lý chi tiết người dùng",
      tabs: {
        userInfo: "Thông tin người dùng",
        loginHistory: "Lịch sử đăng nhập",
        messages: "Tin nhắn",
        chipChangeHistory: "Lịch sử thay đổi chip",
        rechargeHistory: "Lịch sử nạp tiền",
        exchangeHistory: "Lịch sử đổi tiền",
        chipReceivedHistory: "Lịch sử nhận chip",
        chipSentHistory: "Lịch sử gửi chip",
        gamePlayHistory: "Lịch sử chơi game",
        gameBetHistory: "Lịch sử cược game",
        restrictedGameBetting: "Cược game bị hạn chế",
        pragmatic: "Pragmatic",
        userLogs: "Nhật ký người dùng",
      },
      userSummary: {
        role: "Vai trò",
        username: "Tên người dùng",
        chip: "Chip",
        point: "Điểm",
      },
      userInfo: {
        title: "Chi tiết người dùng",
        basicInfo: "Thông tin cơ bản",
        moneyInfo: "Thông tin tài chính",
        gameInfo: "Thông tin game",
        bankInfo: "Thông tin ngân hàng",
        number: "Số",
        password: "Mật khẩu",
        username: "Tên người dùng",
        contact: "Số điện thoại",
        status: "Trạng thái",
        gameVendor: "Nhà cung cấp game",
        gameVendorPlaceholder: "Chọn nhà cung cấp game",
        chip: "Chip",
        point: "Điểm",
        totalDeposit: "Tổng nạp tiền",
        totalWithdraw: "Tổng rút tiền",
        slotBet: "Cược slot",
        slotWin: "Thắng slot",
        casinoBet: "Cược casino",
        casinoWin: "Thắng casino",
        sportsBet: "Cược thể thao",
        sportsWin: "Thắng thể thao",
        casinoBetLimit: "Giới hạn cược casino trực tuyến",
        casinoWinLimit: "Giới hạn thắng casino trực tuyến",
        bankName: "Tên ngân hàng",
        bankAccount: "Số tài khoản",
        bankAccountHolder: "Chủ tài khoản",
        memo: "Ghi chú",
        memoPlaceholder: "Nhập ghi chú",
        createdAt: "Ngày đăng ký",
        lastLogin: "Đăng nhập cuối cùng",
        blockRejectReason: "Lý do chặn/từ chối",
        blockRejectReasonPlaceholder: "Nhập lý do chặn hoặc từ chối",
      },
      loginHistory: {
        title: "Lịch sử đăng nhập",
        columns: {
          ipAddr: "Địa chỉ IP",
          isSuccess: "Thành công",
          createdAt: "Thời gian truy cập",
          actions: "Hành động",
          blockIP: "Chặn IP",
        },
      },
      chipChangeHistory: {
        title: "Lịch sử thay đổi chip",
        columns: {
          amountBefore: "Trước",
          amountAfter: "Sau",
          amountDiff: "Thay đổi",
          sender: "Người gửi",
          receiver: "Người nhận",
          reason: "Lý do",
          referenceValue: "Giá trị tham chiếu",
          rollingBefore: "Rolling (Trước)",
          rollingAfter: "Rolling (Sau)",
          createdAt: "Thời gian thay đổi",
        },
      },
      rechargeHistory: {
        title: "Lịch sử nạp tiền",
        columns: {
          amountBefore: "Trước",
          amountAfter: "Sau",
          requestAmount: "Số tiền yêu cầu",
          bankInfo: "Thông tin ngân hàng",
          status: "Trạng thái",
          requestedAt: "Thời gian yêu cầu",
          processedAt: "Thời gian xử lý",
          memo: "Ghi chú",
        },
      },
      exchangeHistory: {
        title: "Lịch sử đổi tiền",
        columns: {
          amountBefore: "Trước",
          amountAfter: "Sau",
          requestAmount: "Số tiền yêu cầu",
          bankInfo: "Thông tin ngân hàng",
          status: "Trạng thái",
          requestedAt: "Thời gian yêu cầu",
          processedAt: "Thời gian xử lý",
          memo: "Ghi chú",
        },
      },
      chipReceiveHistory: {
        title: "Lịch sử nhận chip",
        columns: {
          receiverId: "ID người nhận",
          receiverUsername: "Tên người nhận",
          receiverRole: "Vai trò người nhận",
          amount: "Số lượng chip",
          reason: "Lý do",
          memo: "Ghi chú",
          createdAt: "Thời gian tạo",
        },
      },
      chipSendHistory: {
        title: "Lịch sử gửi chip",
        columns: {
          senderId: "ID người gửi",
          senderUsername: "Tên người gửi",
          senderRole: "Vai trò người gửi",
          amount: "Số lượng chip",
          reason: "Lý do",
          memo: "Ghi chú",
          createdAt: "Thời gian tạo",
        },
      },
      gamePlayHistory: {
        title: "Lịch sử chơi game",
        columns: {
          supplier: "Nhà cung cấp",
          gameName: "Tên game",
          executionTime: "Thời gian thực hiện",
        },
      },
      gameBetHistory: {
        title: "Lịch sử cược game",
        columns: {
          supplier: "Nhà cung cấp",
          gameName: "Tên game",
          roundId: "ID vòng",
          type: "Loại",
          betAmount: "Số tiền cược",
          winAmount: "Số tiền thắng",
          balance: "Số dư",
          betTime: "Thời gian cược",
          details: "Chi tiết",
        },
      },
    },
    creation: {
      title: "Tạo người dùng",
      desc: "Tạo {0} mới",
      username: "Tên người dùng",
      usernamePlaceholder: "Nhập tên người dùng",
      password: "Mật khẩu",
      passwordPlaceholder: "Nhập mật khẩu",
      count: "Số lượng",
      countPlaceholder: "Nhập số lượng",
      contact: "Số điện thoại",
      contactPlaceholder: "Nhập số điện thoại",
      bank: "Ngân hàng",
      bankSelect: "=== Chọn ===",
      bankKookmin: "Kookmin",
      bankShinhan: "Shinhan",
      bankWoori: "Woori",
      bankNonghyup: "Nonghyup",
      bankHana: "Hana",
      accountNumber: "Số tài khoản",
      accountNumberPlaceholder: "Nhập số tài khoản",
      accountHolder: "Chủ tài khoản",
      accountHolderPlaceholder: "Nhập tên chủ tài khoản",
      rollingRateSlot: "Tỷ lệ phí Rolling (Slot)",
      losingRateSlot: "Tỷ lệ phí Losing (Slot)",
      rollingRateCasino: "Tỷ lệ phí Rolling (Casino)",
      losingRateCasino: "Tỷ lệ phí Losing (Casino)",
      rollingRateSports: "Tỷ lệ phí Rolling (Thể thao)",
      losingRateSports: "Tỷ lệ phí Losing (Thể thao)",
      errors: {
        requiredFields: "Nhập tên người dùng và mật khẩu",
        invalidCount: "Số lượng phải lớn hơn 0",
      },
    },
  },
  partners: {
    common: {
      add: "Thêm đối tác",
    },
    list: {
      all: {
        title: "Danh sách đối tác",
        desc: "Quản lý đối tác đã đăng ký",
      },
      head: {
        title: "Danh sách trụ sở",
        desc: "Quản lý trụ sở đã đăng ký",
      },
      branch: {
        title: "Danh sách chi nhánh",
        desc: "Quản lý chi nhánh đã đăng ký",
      },
      headBranch: {
        title: "Danh sách trụ sở",
        desc: "Quản lý trụ sở đã đăng ký",
      },
      distributor: {
        title: "Danh sách nhà phân phối",
        desc: "Quản lý nhà phân phối đã đăng ký",
      },
      store: {
        title: "Danh sách cửa hàng",
        desc: "Quản lý cửa hàng đã đăng ký",
      },
      search: {
        placeholder: "Nhập tên người dùng đối tác",
      },
      columns: {
        username: "ID người dùng",
        details: "Chi tiết",
        role: "Vai trò",
        banking: "Nạp/Đổi",
        chip: "Số dư chip",
        point: "Số điểm",
        depositWithdraw: "Nạp/Rút",
        rollingPercentage: {
          slot: "Rolling % (Slot)",
          casino: "Rolling % (Casino)",
          sports: "Rolling % (Thể thao)",
        },
        losingPercentage: {
          slot: "Thua % (Slot)",
          casino: "Thua % (Casino)",
          sports: "Thua % (Thể thao)",
        },
        createdAt: "Ngày tạo",
        hqTransactions: "Nạp/Rút trụ sở",
        chipTransactions: "Cấp/Thu thập chip",
        betting: {
          casino: "Cược(Casino)",
          slot: "Cược(Slot)",
          sports: "Cược(Thể thao)",
        },
        downlineManagement: "Quản lý downline",
        createDownline: "Tạo downline",
      },
      statsCard: {
        basicInfo: {
          title: "Thông tin cơ bản",
          type: "Loại",
          username: "Tên người dùng",
          chipAndPointBalance: "Chip / Điểm",
          contact: "Số điện thoại",
          bankName: "Tên ngân hàng",
          bankAccount: "Số tài khoản",
          accountHolder: "Chủ tài khoản",
        },
        rollingAndLosing: {
          title: "Rolling & Thua",
          convertButton: "Chuyển đổi thành số dư",
          rollingPercentage: {
            slot: "Rolling % (Slot)",
            casino: "Rolling % (Casino)",
            sports: "Rolling % (Thể thao)",
          },
          losingPercentage: {
            slot: "Thua % (Slot)",
            casino: "Thua % (Casino)",
            sports: "Thua % (Thể thao)",
          },
        },
        bettingAndRolling: {
          title: "Cược & Rolling",
          bettingWinning: {
            title: "Cược / Thắng",
            slot: "Cược / Thắng (Slot)",
            casino: "Cược / Thắng (Casino)",
            sports: "Cược / Thắng (Thể thao)",
          },
          rolling: {
            slot: "Rolling (Slot)",
            casino: "Rolling (Casino)",
            sports: "Rolling (Thể thao)",
          },
        },
        moneyMovement: {
          title: "Di chuyển tiền",
          totalDeposit: "Tổng nạp tiền",
          totalWithdraw: "Tổng rút tiền",
          totalChipGive: "Tổng cấp chip",
          totalChipCollect: "Tổng thu thập chip",
        },
      },
    },
    chipTransfer: {
      title: "Chuyển chip đối tác",
      desc: "Quản lý chuyển chip đối tác",
      columns: {
        fromUser: "Người gửi",
        fromRole: "Vai trò người gửi",
        toUser: "Người nhận",
        toRole: "Vai trò người nhận",
        amount: "Số lượng",
        memo: "Ghi chú",
        createdAt: "Thời gian chuyển",
      },
    },
    partnerUserChipTransfer: {
      title: "Chuyển chip đối tác ↔ người dùng",
      desc: "Quản lý chuyển chip giữa đối tác và người dùng",
      search: {
        placeholder: "Nhập tên đối tác hoặc người dùng",
      },
      columns: {
        partnerUsername: "Tên đối tác",
        partnerRole: "Vai trò đối tác",
        username: "Tên người dùng",
        giveAmount: "Số lượng đã cấp",
        collectAmount: "Số lượng đã thu thập",
        createdAt: "Thời gian",
      },
    },
  },
  banking: {
    rechargeHistory: {
      title: "Lịch sử nạp tiền",
      desc: "Trang lịch sử nạp tiền",
      columns: {
        id: "#",
        type: "Loại",
        amount: "Số tiền nạp",
        countAndTotal: "Số lần nạp / Tổng",
        balanceChange: "Trước / Sau khi nạp",
        username: "Tên người dùng",
        affiliation: "Liên kết",
        bankName: "Tên ngân hàng",
        accountHolder: "Chủ tài khoản",
        dates: "Thời gian yêu cầu / Thời gian xử lý",
        status: "Trạng thái",
        details: "Chi tiết",
        memo: "Ghi chú",
        deposit: "Nạp tiền",
        withdraw: "Rút tiền",
      },
    },
    exchangeHistory: {
      title: "Lịch sử đổi tiền",
      desc: "Trang lịch sử đổi tiền",
      columns: {
        id: "#",
        type: "Loại",
        amount: "Số tiền đổi",
        countAndTotal: "Số lần đổi / Tổng",
        balanceChange: "Trước / Sau khi đổi",
        username: "Tên người dùng",
        affiliation: "Liên kết",
        bankName: "Tên ngân hàng",
        accountHolder: "Chủ tài khoản",
        dates: "Thời gian yêu cầu / Thời gian xử lý",
        status: "Trạng thái",
        details: "Chi tiết",
        memo: "Ghi chú",
        deposit: "Nạp tiền",
        withdraw: "Rút tiền",
      },
    },
  },
  notices: {
    list: {
      title: "Quản lý thông báo",
      desc: "Trang quản lý thông báo",
      createButton: "Tạo thông báo",
      columns: {
        title: "Tiêu đề",
        status: "Trạng thái",
        viewCount: "Lượt xem",
        createdAt: "Ngày tạo",
        updatedAt: "Ngày cập nhật",
        actions: "Hành động",
        pinButton: "Ghim",
        unpinButton: "Bỏ ghim",
        viewButton: "Xem",
        editButton: "Chỉnh sửa",
        deleteButton: "Xóa",
      },
    },
    detail: {
      title: "Chi tiết thông báo",
      desc: "Trang chi tiết thông báo",
      notFound: "Không tìm thấy thông báo",
    },
    edit: {
      title: "Chỉnh sửa thông báo",
      desc: "Trang chỉnh sửa thông báo",
      titleLabel: "Tiêu đề",
      contentLabel: "Nội dung",
      statusLabel: "Trạng thái",
      pinnedLabel: "Ghim lên đầu",
    },
    delete: {
      title: "Xóa thông báo",
      desc: "Bạn có chắc chắn muốn xóa thông báo này?",
    },
    status: {
      all: "Tất cả",
      draft: "Nháp",
      published: "Đã xuất bản",
      deleted: "Đã xóa",
    },
  },
  inquiry: {
    types: {
      deposit: "Nạp tiền 1:1",
      withdrawal: "Rút tiền 1:1",
      account: "Tạo tài khoản 1:1",
      other: "Khác 1:1",
    },
  },
  inquiries: {
    list: {
      title: "Hỏi đáp 1:1",
      desc: "Trang danh sách hỏi đáp",
      columns: {
        title: "Tiêu đề",
        status: "Trạng thái",
        creator: "Người tạo",
        createdAt: "Ngày tạo",
        answerer: "Người trả lời",
        answeredAt: "Thời gian trả lời",
      },
      search: {
        placeholder: "Tìm kiếm theo tiêu đề hoặc nội dung",
      },
      noData: "Không có lịch sử hỏi đáp",
    },
    detail: {
      title: "Chi tiết hỏi đáp",
      desc: "Trang chi tiết hỏi đáp",
      notFound: "Không tìm thấy hỏi đáp",
    },
    status: {
      all: "Tất cả",
      pending: "Đang chờ",
      inProgress: "Đang xử lý",
      completed: "Đã hoàn thành",
      deleted: "Đã xóa",
    },
    answer: {
      title: "Trả lời",
      status: "Trạng thái",
      content: "Nội dung",
      placeholder: "Nhập câu trả lời của bạn",
      submit: "Gửi câu trả lời",
      success: "Gửi câu trả lời thành công",
      error: "Không thể gửi câu trả lời",
      required: "Vui lòng nhập câu trả lời",
    },
  },
  bettingStatus: {
    common: {
      rollingDesc: "※ Rolling = Cược x Rolling%, ※ Thực tế = Rolling - Rolling downline",
      losingDesc: "※ Thua = (Cược - Thắng - Tổng Rolling) x Rolling%, ※ Thực tế = Thua - Thua downline",
      selectedPartner: "Dữ liệu cược & rolling của đối tác đã chọn",
      downlinePartners: "Dữ liệu cược & rolling của đối tác downline",
    },
    slot: {
      title: "Trạng thái cược (Slot)",
      desc: "Trang trạng thái cược slot",
    },
    casino: {
      title: "Trạng thái cược (Casino)",
      desc: "Trang trạng thái cược casino",
    },
    sports: {
      title: "Trạng thái cược (Thể thao)",
      desc: "Trang trạng thái cược thể thao",
    },
    slotHistory: {
      title: "Lịch sử cược (Slot)",
      desc: "Trang lịch sử cược slot",
    },
    casinoHistory: {
      title: "Lịch sử cược (Casino)",
      desc: "Trang lịch sử cược casino",
    },
    sportsHistory: {
      title: "Lịch sử cược (Thể thao)",
      desc: "Trang lịch sử cược thể thao",
    },
    losingSettlement: {
      slot: {
        title: "Lợi nhuận lỗ (Slot)",
        desc: "Trang lợi nhuận lỗ slot",
      },
      casino: {
        title: "Lợi nhuận lỗ (Casino)",
        desc: "Trang lợi nhuận lỗ casino",
      },
      sports: {
        title: "Lợi nhuận lỗ (Thể thao)",
        desc: "Trang lợi nhuận lỗ thể thao",
      },
      columns: {
        role: "Vai trò",
        partnerName: "Tên đối tác",
        totalPartnerDeposit: "Tổng nạp tiền đối tác",
        totalPartnerWithdraw: "Tổng rút tiền đối tác",
        totalBetting: "Tổng cược",
        totalWinning: "Tổng thắng",
        bettingResult: "Cược - Thắng",
        rollingPercentage: "Rolling %",
        totalRolling: "Tổng rolling",
        actualRolling: "Rolling thực tế",
        losingPercentage: "Thua %",
        losingAmount: "Thua lỗ",
        settlementAmount: "Lợi nhuận lỗ",
        downlineSettlementAmount: "Lợi nhuận lỗ downline",
        actualPaymentAmount: "Lợi nhuận lỗ thực tế",
      },
    },
    lossAdjustment: {
      title: "Điều chỉnh thua lỗ",
      desc: "Trang điều chỉnh thua lỗ",
      columns: {
        headquarter: "Trụ sở",
        branch: "Phòng giao dịch",
        storeUsername: "Tên cửa hàng",
        yesterdayBetting: "Cược hôm qua",
        yesterdayWin: "Thắng hôm qua",
        yesterdayRolling: "Rolling hôm qua",
        subtract: "Trừ",
        loss: "THUA LỖ",
        add: "Cộng",
      },
      buttons: {
        setAll0: "Đặt tất cả thành 0",
        setAll5: "Đặt tất cả thành 5",
        setAll10: "Đặt tất cả thành 10",
        setAll15: "Đặt tất cả thành 15",
        setAll20: "Đặt tất cả thành 20",
      },
    },
    lossRecovery: {
      title: "Khôi phục thua lỗ",
      desc: "Trang khôi phục thua lỗ",
      columns: {
        storeName: "Tên cửa hàng",
        username: "Tên người dùng",
        gameName: "Tên game",
        date: "Ngày",
        bettingAmount: "Số tiền cược",
        winningAmount: "Số tiền thắng",
        rollingAmount: "Số tiền rolling",
        storeRecoveryStatus: "Trạng thái khôi phục cửa hàng",
        userRecoveryStatus: "Trạng thái khôi phục người dùng",
        status: "Trạng thái",
      },
    },
    bettingStatusColumns: {
      role: "Vai trò",
      partnerName: "Tên đối tác",
      totalPartnerDeposit: "Tổng nạp tiền đối tác",
      totalPartnerWithdraw: "Tổng rút tiền đối tác",
      totalBetting: "Tổng cược",
      totalWinning: "Tổng thắng",
      bettingResult: "Cược - Thắng",
      rollingPercentage: "Rolling %",
      totalRolling: "Tổng rolling",
      actualRolling: "Rolling thực tế",
      bettingProfit: "Lợi nhuận cược",
      currentChip: "Chip hiện tại",
      currentRolling: "Rolling hiện tại",
    },
  },
  swagger: {
    title: "Tài liệu API",
    description: "Tài liệu API Quản trị Piggy Vault.",
  },
  settings: {
    title: "Cài đặt",
    description: "Quản lý cài đặt hệ thống",
    tabs: {
      general: "Tổng quan",
      currency: "Tiền tệ",
      exchange: "Tỷ giá",
      game: "Game",
      etc: "Khác",
    },
    groups: {
      general: {
        title: "Cài đặt tổng quan",
        description: "Cấu hình cài đặt hệ thống tổng quan.",
      },
      currency: {
        title: "Cài đặt tiền tệ",
        description: "Quản lý hiển thị tiền tệ và cài đặt tiêu chuẩn.",
      },
      exchange: {
        title: "Cài đặt tỷ giá",
        description: "Quản lý cài đặt tỷ giá USDT.",
      },
      game: {
        title: "Cài đặt game",
        description: "Cấu hình cài đặt game, bao gồm nhà cung cấp.",
      },
      etc: {
        title: "Cài đặt khác",
        description: "Quản lý cài đặt khác.",
      },
    },
    fields: {
      site_name: {
        label: "Tên trang web",
        description: "Tên trang web.",
      },
      maintenance: {
        label: "Trạng thái bảo trì",
        description: "Bật hoặc tắt trạng thái bảo trì trang web. (on/off)",
      },
      std_currency: {
        label: "Tiền tệ tiêu chuẩn",
        description: "Tiền tệ tiêu chuẩn cho tính toán.",
      },
      dsp_currency: {
        label: "Tiền tệ hiển thị",
        description: "Tiền tệ hiển thị cho người dùng.",
      },
      usdt_exchange_rate: {
        label: "Cài đặt tỷ giá USDT",
        description: "Trình chỉnh sửa dữ liệu JSON tỷ giá USDT.",
      },
      std_game_vendor_id: {
        label: "Nhà cung cấp game tiêu chuẩn",
        description: "ID nhà cung cấp game tiêu chuẩn.",
      },
      // 다른 필드들에 대한 번역도 여기에 추가할 수 있습니다.
    },
    messages: {
      settingKeyNotFound: "Không tìm thấy chỉ số cho khóa cài đặt '$key'",
      loadingSettings: "Đang tải cài đặt...",
      errorLoadingSettings: "Lỗi tải cài đặt",
    },
    save_success: "Cài đặt đã được lưu thành công!",
  },
  usdtExchangeRateEditor: {
    rawJsonEditorTitle: "Trình chỉnh sửa JSON thô",
    exchangeRateAndWalletSettingsTitle: "Cài đặt tỷ giá và ví",
    usdtExchangeRateLabel: "Tỷ giá USDT (ex_rate)", 
    myWalletUrlLabel: "URL ví của tôi (my_wallet)",
    quickAmountsSettingsTitle: "Cài đặt số tiền nhanh:",
    quickAmounts: {
      hide: "(Ẩn)",
      show: "(Hiện)",
      amountPlaceholder: "Số tiền",
      labelPlaceholder: "Nhãn (ví dụ: $10)",
      addAmountButton: "Thêm số tiền nhanh",
    },
    addLanguagePrompt: "Nhập mã ngôn ngữ để thêm (ví dụ: th):",
    languageExistsError: "Cài đặt ngôn ngữ đã tồn tại.",
    addNewLanguageQuickAmountButton: "Thêm số tiền nhanh cho ngôn ngữ mới",
    wallets: {
      title: "Danh sách ví rút tiền (wallets)",
      walletNumberLabel: "Ví",
      namePlaceholder: "Tên ví (ví dụ: Polygon Tether)",
      addressPlaceholder: "Địa chỉ ví",
      qrPlaceholder: "Đường dẫn mã QR (ví dụ: /uploads/polygon-img.jpeg)",
      deleteWalletButton: "Xóa ví này",
      addWalletButton: "Thêm ví rút tiền",
    },
    errors: {
      invalidJsonParse: "Định dạng JSON không hợp lệ",
      failedStringifyJson: "Không thể chuyển đổi chuỗi JSON (onChange)",
      invalidJsonFormatOrUseUI:
        "Định dạng JSON không hợp lệ. Vui lòng chỉnh sửa trực tiếp hoặc sử dụng giao diện bên dưới.",
    },
    rawJsonEditor: {
      editJsonDirectlyLabel: "Chỉnh sửa JSON trực tiếp",
      warningMessage:
        "Cảnh báo: Cài đặt có thể không được lưu chính xác nếu định dạng JSON không đúng.",
    },
    loadingEditor: "Đang tải trình chỉnh sửa...",
  },
};

export default data;
